import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthService } from '../../../services/auth.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent implements OnInit{
  public passwordForm!: FormGroup;
  passwordStrenth: any;
  constructor(
    public ref: DynamicDialogRef,
    private authservice: AuthService,
    private messageService: MessageService,
    private router: Router
  ){

  }
  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.passwordForm = new FormGroup({
      old_password: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
      ]),
      new_password: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
      ]),
      confirm_password: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
      ]),
    });
  }
  onCancel(){
    this.ref.close();
  }
  onUpdate(){
    if (this.passwordForm.value.new_password == this.passwordForm.value.confirm_password){
      if(this.passwordForm.valid){
        this.authservice.changePassword(this.passwordForm.value).subscribe({
          next: ( data ) =>{
            this.messageService.add({ severity: 'success', summary: 'Success', detail: `${data.detail}` });
            this.ref.close();
            setTimeout(() => {
              this.router.navigate(['/auth/login']);
          }, 600);
          },
          error: ({ error }: any) => {
            const errorKey = ['old_password', 'new_password', 'confirm_password'].find(key => error?.[key]);
            const errorMessage = errorKey ? error[errorKey][0] : error?.error;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
          }
        })
      }
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: `Confirm Password entered doesn’t match, Please try again.` });
    }
  }
}
